import "./SectionThreeSliderCard.css";

import React from "react";

import { Link } from "react-router-dom";

import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export const SectionThreeSliderCard = ({
  isOnSale,
  imgSrc,
  name,
  description,
  price,
  oldPrice,
  itemId,
}) => {
  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="slider-card">
      <div className="sale-sticker-container">
        <div></div>
        {isOnSale === true && (
          <div className="sale-sticker-actual">ПРОМО !</div>
        )}
      </div>

      <Link
        onClick={handleMoveToTop}
        to={`/shop/item:${itemId}`}
        className="slider-card-image-container"
      >
        <img className="slider-card-image" src={imgSrc} alt="Loading"></img>
      </Link>
      <Link
        onClick={handleMoveToTop}
        to={`/shop/item:${itemId}`}
        className="slider-card-name"
      >
        {name}
      </Link>

      <p
        style={{ color: isOnSale === true ? "brown" : "rgb(41,41,41)" }}
        className="slider-card-price"
      >
        {isOnSale === true && (
          <p className="slider-card-old-price">{oldPrice}лв.</p>
        )}
        {price}лв.
      </p>
      <Link
        onClick={handleMoveToTop}
        to={`/shop/item:${itemId}`}
        className="slider-card-button"
      >
        <ShoppingCartIcon sx={{ fontSize: "16px" }} />
        <p className="slider-card-button-text">разгледай</p>
      </Link>
    </div>
  );
};
